import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CancelReceiveMailPopupPage } from './cancel-receive-mail-popup.page';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  declarations: [CancelReceiveMailPopupPage]
})
export class CancelReceiveMailPopupPageModule {}
